module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.fails.js
// module id = ./node_modules/core-js/library/modules/$.fails.js
// module chunks = 11056403903869698000